import { Entity } from '@adornis/baseql/decorators.js';
import { BaseEditExtension } from '../BaseEditExtension.js';

@Entity()
export class BasePartnerEditContactPersonExtension extends BaseEditExtension {
  static override _class = 'BasePartnerEditContactPersonExtension';
}
